module.exports = {
  welcome: {
    es: "Bienvenido",
    en: "Welcome",
  },
  loginToContinue: {
    es: "Inicia sesión para continuar",
    en: "Log in to continue",
  },
  spanish: {
    es: "Español",
    en: "Spanish",
  },
  english: {
    es: "Ingles",
    en: "English",
  },
  loginIdOrEmail: {
    es: "LoginID o Correo electrónico",
    en: "LoginID or Email",
  },
  password: {
    es: "Contraseña",
    en: "Password",
  },
  login: {
    es: "Iniciar sesión",
    en: "LogIn",
  },
  forgotYourPassword: {
    es: "¿Olvidaste tu contraseña?",
    en: "Forgot your password?",
  },
  socialNetworks: {
    es: "Redes sociales",
    en: "Social networks",
  },
  contact: {
    es: "Contacto",
    en: "Contact",
  },
  cookiesPolicy: {
    es: "Política de cookies",
    en: "Cookies policy",
  },
  privacyPolicy: {
    es: "Política de privacidad",
    en: "Privacy Policy",
  },
  weeks: {
    es: "Semanas",
    en: "Weeks",
  },
  country: {
    es: "País",
    en: "Country",
  },
  countrySelected: {
    es: "Selecciona un país",
    en: "Select a country",
  },
  state: {
    es: "Estado",
    en: "State",
  },
  stateSelected: {
    es: "Selecciona un estado",
    en: "Select a state",
  },
  city: {
    es: "Ciudad",
    en: "City",
  },
  citySelected: {
    es: "Selecciona una ciudad",
    en: "Select a city",
  },
  allCity: {
    es: "Todas las ciudades",
    en: "All cities",
  },
  checkIn: {
    es: "Check In",
    en: "Check In",
  },
  checkOut: {
    es: "Check Out",
    en: "Check Out",
  },
  totalPrice: {
    es: "Precio Total",
    en: "Total price",
  },
  moreDetails: {
    es: "Más detalles",
    en: "More details",
  },
  seeAvailableUnits: {
    es: "Ver unidades disponibles",
    en: "See available units",
  },
  unitsAvailable: {
    es: "unidades disponibles",
    en: "units available",
  },
  fromPrice: {
    es: "Desde",
    en: "From",
  },
  availableIn: {
    es: "disponibles en",
    en: "available in",
  },
  editSearch: {
    es: "Editar búsqueda",
    en: "Edit search",
  },
  nonRefundable: {
    es: "No reembolsable",
    en: "Non Refundable",
  },
  agency: {
    es: "Agencia",
    en: "Agency",
  },
  interestedLinks: {
    es: "Enlaces de interés",
    en: "Interest links",
  },
  commentsSupport: {
    es: "Comentarios/Soporte",
    en: "Comments/Support",
  },
  hotelsFlightsMore: {
    es: "Hoteles, vuelos y más ...",
    en: "Hotels, flights and more ...",
  },
  myProfile: {
    es: "Mi perfil",
    en: "My profile",
  },
  myAccount: {
    es: "Mi cuenta",
    en: "My account",
  },
  find: {
    es: "Buscar",
    en: "Search",
  },
  nights: {
    es: "Noches",
    en: "Nights",
  },
  pay: {
    es: "Pagar",
    en: "Pay",
  },
  morePictures: {
    es: "Más fotos",
    en: "More pictures",
  },
  aboutProperty: {
    es: "Sobre la Propiedad",
    en: "About the Property",
  },
  services: {
    es: "Servicios",
    en: "Services",
  },
  policies: {
    es: "Políticas",
    en: "Policies",
  },
  importantInformation: {
    es: "Información Importante",
    en: "Important Information",
  },
  payNow: {
    es: "Pagar ahora",
    en: "Pay now",
  },
  successfulPayment: {
    es: "Pago procesado con éxito",
    en: "Payment successfully processed",
  },
  sentByEmail: {
    es: "Te hemos enviado todos los detalles a tu correo electrónico",
    en: "We have sent all the details to your email",
  },
  reservationRef: {
    es: "Referencia",
    en: "Reference",
  },
  reserving: {
    es: "Reservando",
    en: "Reserving",
  },
  startingStripe: {
    es: "Iniciando Stripe",
    en: "Starting Stripe",
  },
  all: {
    es: "Todos",
    en: "All",
  },
  weekType: {
    es: "Tipo de semana",
    en: "Week Type",
  },
  loadingDescription: {
    es: "Cargando descripción",
    en: "Loading description",
  },
  loadingResortName: {
    es: "Cargando nombre",
    en: "Loading name",
  },
  resortSummary: {
    es: "Resumen del Resort",
    en: "Resort Summary",
  },
  enterTravelerData: {
    es: "Ingresa los datos del viajero",
    en: `Enter the traveler's data`,
  },
  primaryContact: {
    es: "Contacto Primario",
    en: "Primary Contact",
  },
  mandatory: {
    es: "Obligatorio",
    en: "Mandatory",
  },
  termsAndConditions: {
    es: "Términos y Condiciones",
    en: "Terms and Conditions",
  },
  smsMessagingPolicy: {
    es: "Política de Mensajería SMS",
    en: "SMS Messaging Policy",
  },
  msgTermsAndConditions: {
    es: "He leído y acepto las condiciones de uso, las observaciones de la reserva y los gastos de cancelación.",
    en: "I have read and I accept the conditions of use, the booking remarks and cancellation costs.",
  },
  name: {
    es: "Nombre",
    en: "Name",
  },
  next: {
    es: "Continuar",
    en: "Next",
  },
  back: {
    es: "Volver",
    en: "Go back",
  },
  lastname: {
    es: "Apellido",
    en: "Last Name",
  },
  email: {
    es: "Correo Electrónico",
    en: "E-mail",
  },
  cellphone: {
    es: "Celular",
    en: "Mobile Phone",
  },
  phone: {
    es: "Teléfono",
    en: "Phone",
  },
  countryCode: {
    es: "Código País",
    en: "Country Code",
  },
  address: {
    es: "Dirección",
    en: "Address",
  },
  zip: {
    es: "Código Postal",
    en: "Zip Code",
  },
  book: {
    es: "Reservar",
    en: "Book",
  },
  finalPrice: {
    es: "Precio Final",
    en: "Final Price",
  },
  msgConfirmPayment: {
    es: "Tienes 30 minutos a partir de ahora para completar el pago. Si necesita más tiempo por favor regrese y confirme el viaje nuevamente antes de pagar. *Precios y disponibilidad no están garantizados.",
    en: "You have 30 minutes from now to complete payment. If you need more time please go back and confirm the trip again before paying. *Prices and availability are not guaranteed.",
  },
  warning: {
    es: "Alerta",
    en: "Warning",
  },
  paymentOptions: {
    es: "Opciones de pago",
    en: "Payment options",
  },
  paymentSystem: {
    es: "Sistema de pago",
    en: "Payment system",
  },
  orderBy: {
    es: "Ordenar por",
    en: "Order by",
  },
  shareSearch: {
    es: "Compartir búsqueda",
    en: "Share search",
  },
  shareResort: {
    es: "Compartir resort",
    en: "Share resort",
  },
  shareWeek: {
    es: "Compartir esta semana",
    en: "Share this week",
  },
  shareSearchTitle: {
    es: "Compartir esta búsqueda",
    en: "Share this search",
  },
  shareResortTitle: {
    es: "Compartir este resort",
    en: "Share this resort",
  },
  shareWeekTitle: {
    es: "Compartir esta semana",
    en: "Share this week",
  },
  copyLink: {
    es: "Copiar link",
    en: "Copy link",
  },
  linkCopied: {
    es: "Link copiado. Pégalo en tu correo o mensaje.",
    en: "Link copied. Paste it in your email or message.",
  },
  linkCopiedShort: {
    es: "Link copiado",
    en: "Link copied",
  },
  shareNote: {
    es: "Quien abra este link tendrá que iniciar sesión con su propia cuenta. Tu sesión no se incluye.",
    en: "Anyone who opens this link will need to sign in with their own account. Your session is not included.",
  },
  shareFilters: {
    es: "Filtros",
    en: "Filters",
  },
  sharedLoginNotice: {
    es: "Inicia sesión para ver la búsqueda que te compartieron.",
    en: "Sign in to see the vacation search that was shared with you.",
  },
  weekNoLongerAvailable: {
    es: "Esta semana ya no está disponible. Estas son otras semanas en {resort} para las mismas fechas.",
    en: "This week is no longer available. Here are other weeks at {resort} for the same dates.",
  },
  priceLowest: {
    es: "Precio (El más bajo primero)",
    en: "Price (lowest first)",
  },
  priceHighest: {
    es: "Precio (El más alto primero)",
    en: "Price (highest first)",
  },
  capacity: {
    es: "Tipo de unidad",
    en: "Unit Type",
  },
  kitchen: {
    es: "Cocina",
    en: "Kitchen",
  },
  occupancy: {
    es: "Max. Ocupación",
    en: "Max. Occupancy",
  },
  resortSelect: {
    es: "Nombre del Resort",
    en: "Resort Name",
  },
  resetFilters: {
    es: "Restablecer filtros",
    en: "Reset Filters",
  },
  recoverPassword: {
    es: "Recuperar contraseña",
    en: "Recover Password",
  },
  recoverPasswordMsg: {
    es: "Introduce tu correo electrónico",
    en: "Enter your email address",
  },
  recoverPasswordMsg2: {
    es: "Recibirás un correo electrónico con instrucciones para restablecer tu contraseña.",
    en: "You will receive an email with instructions to reset your password",
  },
  recoverPasswordMs32: {
    es: "Recibirás un correo electrónico con un código de un solo uso",
    en: "You will receive an email with one-time code",
  },
  emailSend: {
    es: "Correo electrónico enviado",
    en: "Email send",
  },
  resetPassword: {
    es: "Restablecer contraseña",
    en: "Reset password",
  },
  newPassword: {
    es: "Nueva contraseña",
    en: "New password",
  },
  confirmPassword: {
    es: "Confirmar contraseña",
    en: "Confirm password",
  },
  notMatchPassword: {
    es: "Las contraseñas no coinciden",
    en: "Passwords do not match",
  },
  resetPasswordOk: {
    es: "Cambio de contraseña exitoso",
    en: "Successful password change",
  },
  logout: {
    es: "Cerrar sesión",
    en: "Logout",
  },
  maxOccupancy: {
    es: "Max. Ocupación",
    en: "Max. Occupancy",
  },
  cruises: {
    es: "Cruceros",
    en: "Cruises",
  },
  destination: {
    es: "Destino",
    en: "Destination",
  },
  allDestinations: {
    es: "Todos los Destino",
    en: "All Destinations",
  },
  depPort: {
    es: "Puerto de salida",
    en: "Dep Port",
  },
  allPorts: {
    es: "Todos los Puertos",
    en: "All Ports",
  },
  cruiseLine: {
    es: "Línea de Cruceros",
    en: "Cruise Line",
  },
  allCruiseLines: {
    es: "todas las líneas de cruceros",
    en: "All cruise lines",
  },
  ship: {
    es: "Barco",
    en: "Ship",
  },
  allShips: {
    es: "Todos los barcos",
    en: "All ships",
  },
  month: {
    es: "Mes",
    en: "Month",
  },
  allMonths: {
    es: "All Months",
    en: "Todos los Meses",
  },
  numberOfDay: {
    es: "Número de Días",
    en: "Number of Days",
  },
  allLengths: {
    es: "Todas las Longitudes",
    en: "All Lengths",
  },
  infoImportan__msg1: {
    es: "Todas las reservaciones no son cancelables.",
    en: "All reservations are final.",
  },
  close: {
    es: "Cerrar",
    en: "Close",
  },
  cookiesPolicy__msg1: {
    es: `Utilizamos cookies propias y de terceros (Google y
        Facebook) para analizar el uso de nuestro sitio web, mostrarle
        Anuncios personalizados según tus hábitos de navegación y mejorar.
        rendimiento de navegación.`,
    en: `We use first-party and third-party cookies (Google and
        Facebook) to analyze the usage of our website, show you
        tailored ads according your browsing habits and improve
        browsing performance.`,
  },
  accept: {
    es: "Aceptar",
    en: "Accept",
  },
  completeSearch: {
    es: "Búsqueda completa",
    en: "Complete search",
  },
  filters: {
    es: "Filtros",
    en: "Filters",
  },
  allFieldsRequired: {
    es: "Todos los campos son requeridos",
    en: "All fields are required",
  },
  fieldStateRequired: {
    es: "Para el país {{country}} es necesario seleccionar su estado",
    en: "For the country {{country}} you need to select your state",
  },
  fieldOnlyLettersAndSpaces: {
    es: "El campo {{field}} solo admite letras y espacios",
    en: "The field {{field}} only accepts letters and spaces",
  },
  acceptTerms: {
    es: "Aceptar los términos y condiciones es requerido",
    en: "Accepting the terms and conditions is required",
  },
  emailInvalid: {
    es: "El formato Email no es valido",
    en: "Email format is not valid",
  },
  passwordRecovery: {
    es: "Si encontramos una cuenta que coincida en nuestros registros, se enviará un correo electrónico con las instrucciones para restablecer tu contraseña a tu dirección de correo electrónico registrada.",
    en: "If we find a matching account in our records, an email with instructions on how to reset your password will be sent to your registered email address.",
  },
  checkInOrderHighest: {
    es: "CheckIn (El más alto primero)",
    en: "Check In (highest first)",
  },
  checkInOrderLowest: {
    es: "CheckIn (El más bajo primero)",
    en: "Check In (lowest first)",
  },
  update: {
    es: "Actualizar",
    en: "Update",
  },
  security: {
    es: "Seguridad",
    en: "Security",
  },
  myData: {
    es: "Mis datos",
    en: "My Data",
  },
  updatePassword: {
    es: "Actualizar contraseña",
    en: "Update Password",
  },
  subscription: {
    es: "Suscripción",
    en: "Subscription",
  },
  birthdate: {
    es: "Fecha de nacimiento",
    en: "Birthdate",
  },
  contract: {
    es: "Contrato",
    en: "Contract",
  },
  nacionality: {
    es: "Nacionalidad",
    en: "Nationality",
  },
  maritalStatus: {
    es: "Estado civil",
    en: "Marital Status",
  },
  selectOption: {
    es: "Seleccione una opción",
    en: "Select an option",
  },
  owner: {
    es: "Titular",
    en: "Owner",
  },
  coOwner: {
    es: "Co-titular",
    en: "Co-owner",
  },
  payments: {
    es: "Pagos",
    en: "Payments",
  },
  contactUs: {
    es: "Contáctanos",
    en: "Contact us",
  },
  loginError__msg1: {
    es: "Tu contraseña es incorrecta o esta cuenta no existe. Por favor restablece tu contraseña o contáctanos.",
    en: "Your password is incorrect or this account doesn’t exist. Please reset your password or contact us.",
  },
  changePassword: {
    es: "Cambiar contraseña",
    en: "Change password",
  },
  changePassword__msg1: {
    es: "Por favor, introduce tu nueva contraseña",
    en: "Please, introduce your new password",
  },
  changePassword__msg2: {
    es: "La contraseña debe tener al menos 8 caracteres, 1 minúscula, 1 mayúscula, 1 número, 1 carácter especial y sin espacios en blanco.",
    en: "Password must have at least 8 characters, 1 lowercase, 1 uppercase, 1 number, 1 special character and without blank spaces.",
  },
  changePassword__msg3: {
    es: "La contraseña no cumple con los requisitos de seguridad, intente nuevamente.",
    en: "Password does not meet the security requirements, try again.",
  },
  changePassword__msg4: {
    es: "Hubo un error al cambiar la contraseña, intente nuevamente o contacte con soporte.",
    en: "There was an error changing the password, try again or contact support.",
  },
  changePassword__msg5: {
    es: "El token para cambiar la contraseña expiró, reenvie el correo electrónico para que puedas cambiar tu contraseña.",
    en: "The token to change the password has expired, please send the email again to change your password.",
  },
  termsAndConditions__msg1: {
    es: "He leído y acepto los términos y condiciones",
    en: "I have read and accept the terms and conditions",
  },
  termsAndConditions__msg2: {
    es: "No acepto los términos y condiciones",
    en: "I do not accept the terms and conditions",
  },
  iAccept: {
    es: "Acepto",
    en: "I accept",
  },
  cancel: {
    es: "Cancelar",
    en: "Cancel",
  },
  resortAll: {
    es: "Todos los Resorts",
    en: "All Resorts",
  },
  citySelect: {
    es: "Ciudad",
    en: "City",
  },
  cityAll: {
    es: "Todas las Ciudades",
    en: "All Cities",
  },
  allCities: {
    es: "Todas las ciudades",
    en: "All cities",
  },
  weeksIn: {
    es: "Semanas en",
    en: "Weeks in",
  },
  internalError: {
    es: "Error interno, intente nuevamente o contactenos.",
    en: "Internal error, try again or contact us.",
  },
  newUser: {
    es: "Nuevo Usuario",
    en: "New User",
  },
  registerUser: {
    es: "Registrar Usuario",
    en: "Register User",
  },
  registerUserWithGoogle: {
    es: "Registrar Usuario con Google",
    en: "Register User with Google",
  },
  loginWithGoogle: {
    es: "Iniciar sesión con Google",
    en: "Login with Google",
  },
  registerUser__msg1: {
    es: "Registro exitoso, inicie sesión para continuar",
    en: "Registration successful, log in to continue",
  },
  registerUser__msg2: {
    es: "Registro y pago exitoso, inicie sesión para continuar",
    en: "Registration and payment successful, log in to continue",
  },
  sendCode: {
    es: "Enviar código",
    en: "Send code",
  },
  emailVerification: {
    es: "Verificación de correo electrónico",
    en: "Email verification ",
  },
  emailVerification__msg1: {
    es: "Ingrese el código de verificación de 4 dígitos que se envió a su correo electrónico.",
    en: "Enter the 4-digit verification code that was sent to your email.",
  },
  emailVerification__msg2: {
    es: "Ingrese el código de verificación de 4 dígitos que se envió a su correo electrónico y su nueva contraseña.",
    en: "Enter the 4-digit verification code that was sent to your email and your new password.",
  },
  DidntReceiveCode: {
    es: "¿No has recibido el código?",
    en: "Didn't receive code?",
  },
  resend: {
    es: "Reenviar",
    en: "Resend",
  },
  DidyouRememberYourPassword: {
    es: "¿Recordaste tu contraseña?",
    en: "Did you remember your password?",
  },
  DoYouWantToUseAnotherEmail: {
    es: "¿Quieres usar otro correo electrónico?",
    en: "Do you want to use another email?",
  },
  internalError2: {
    es: "Hubo un error inesperado, verifica tu código OTP e inténtalo de nuevo. Si persistes, contacta con soporte.",
    en: "There was an unexpected mistake, check your OTP code and try it again. If you persist, contact support.",
  },
  fastLogin: {
    es: "Iniciar sesion inmediatamente",
    en: "Start session immediately",
  },
  changePassword__msg6: {
    es: "Hubo un error al cambiar la contraseña, verifica el código OTP e intente nuevamente. Si persistes, contacta con soporte.",
    en: "There was an error when changing the password, verifies the OTP code and try again. If you persist, contact support.",
  },
  changePassword__msg7: {
    es: "¿Ya tienes un código unico?",
    en: "Do you have a one-time code?",
  },
  validateCode: {
    es: "Validar código",
    en: "Validate code",
  },
  codeVerification: {
    es: "Verificación de código único",
    en: "Single code verification",
  },
  codeVerification__msg1: {
    es: "Ingresa el código de verificación de 4 dígitos que enviamos a tu correo electrónico y número de telefono asociado. Si no lo recibes, revisa tu carpeta de correo no deseado (spam).",
    en: "Enter the 4 -digit verification code that we send to your email and associated telephone number. If you do not receive it, check your unwanted mail folder (spam).",
  },
  saveDevice: {
    es: "Recuérdame en este dispositivo",
    en: "Remember me on this device",
  },
  createAnAccount: {
    es: "Crear una cuenta",
    en: "Create an account",
  },
  registerFree: {
    es: "Regístrate gratis aquí",
    en: "Register for free here",
  },
  createUser: {
    es: "Crear usuario",
    en: "Create user",
  },
  changePassword__msg8: {
    es: "Seguridad baja",
    en: "Low security",
  },
  changePassword__msg9: {
    es: "Seguridad Media",
    en: "Medium Security",
  },
  changePassword__msg10: {
    es: "Seguridad alta",
    en: "High security",
  },
  termsAndConditions__msg3: {
    es: "Mediante la marcación de esta casilla, autorizo expresamente al tratamiento de mis datos detalladas en los términos y condiciones, y en las politicas de privacidad.",
    en: "By marking this box, I expressly authorize my data detailed in the terms and conditions, and in privacy policies.",
  },
  termsAndConditions__msg4: {
    es: "Haciendo click en Registrarse, acepto los",
    en: "By clicking on registering, I accept the",
  },
  and: {
    es: "y",
    en: "and",
  },
  dataUpdate: {
    es: "Por favor confirma tus datos a continuación",
    en: "Please confirm your details below",
  },
  welcomeMembership__title: {
    es: "Bienvenido a tu membresía",
    en: "Welcome to your membership",
  },
  welcomeMembership__text: {
    es: "Agenda un tutorial rápido y te mostraremos cómo aprovechar al máximo cada beneficio de tu membresía.",
    en: "Book a quick tutorial and we'll show you how to make the most of every benefit in your membership.",
  },
  welcomeMembership__scheduleTitle: {
    es: "Agenda un tutorial",
    en: "Schedule a tutorial",
  },
  welcomeMembership__recommended: {
    es: "Recomendado",
    en: "Recommended",
  },
  welcomeMembership__learningHub: {
    es: "¿Prefieres explorar por tu cuenta? Mira los videos del Learning Hub",
    en: "Prefer to explore on your own? Watch the Learning Hub videos",
  },
  welcomeMembership__skipForNow: {
    es: "Saltar por ahora",
    en: "Skip for now",
  },
  welcomeMembership__back: {
    es: "Volver",
    en: "Back",
  },
  welcomeMembership__login: {
    es: "Iniciar sesión",
    en: "Log in",
  },
  skip: {
    es: "Saltar",
    en: "Skip",
  },
  cellphoneCode: {
    es: "Código de celular",
    en: "Mobile phone code",
  },
  phoneCode: {
    es: "Código de teléfono",
    en: "Phone code",
  },
  language: {
    es: "Idioma",
    en: "Language",
  },
  gender: {
    es: "Género",
    en: "Gender",
  },
  preferablyLanguage: {
    es: "Idioma Preferido",
    en: "Preferred Language",
  },
  save: {
    es: "Confirmar y continuar",
    en: "Confirm & Continue",
  },
  notForNow: {
    es: "Por ahora no",
    en: "Not for now",
  },
  notSave: {
    es: "Omitir",
    en: "Dismiss",
  },
  male: {
    es: "Masculino",
    en: "Male",
  },
  female: {
    es: "Femenino",
    en: "Female",
  },
  other: {
    es: "Prefiero no responder",
    en: "I prefer not to answer",
  },
  mandatoryField: {
    es: "Campo obligatorio",
    en: "Mandatory field",
  },
  updateData__note1: {
    es: "Nota: Sus datos serán utilizados exclusivamente para procesar su solicitud con nosotros, no los utilizaremos para nada más.",
    en: "Note: Your data will be used exclusively to process your application with us, we will not use them for anything else.",
  },
  updateData__note2: {
    es: "Me interesa recibir boletines informativos y ofertas exclusivas.",
    en: "I am interested in receiving informative newsletters and exclusive offers.",
  },
  checkPass__1: {
    es: "8 Caracteres",
    en: "8 Characters",
  },
  checkPass__2: {
    es: "1 Minúscula",
    en: "1 Lowercase",
  },
  checkPass__3: {
    es: "1 Mayúscula",
    en: "1 Uppercase",
  },
  checkPass__4: {
    es: "1 Número",
    en: "1 Number",
  },
  checkPass__5: {
    es: "1 Carácter Especial",
    en: "1 Special Character",
  },
  checkPass__6: {
    es: "Sin espacios",
    en: "No spaces",
  },
  goToChangePassword: {
    es: "Ir a cambiar la contraseña",
    en: "Go to change the password",
  },
  verifyCode: {
    es: "Verificar código",
    en: "Verify code",
  },
  saving: {
    es: "Guardando...",
    en: "Saving...",
  },
  mandatoryField__msg1: {
    es: "Verifique todos los datos obligatorios e intente de nuevo",
    en: "Verify all mandatory data and try again",
  },
  mandatoryUpdatePassword: {
    es: "Cambiar la contraseña es obligatorio",
    en: "Change password is mandatory",
  },
  mandatoryField__msg2: {
    es: "El teléfono o el celular no posee un formato valido",
    en: "The phone or cellphone does not have a valid format",
  },
  mandatoryField__msg3: {
    es: "El correo electrónico no posee un formato valido",
    en: "The email does not have a valid format",
  },
  acceptSMSPolicy: {
    es: "Aceptar la política de SMS es requerido",
    en: "Accepting the SMS policy is required",
  },
  ratingOrderHighest: {
    es: "Calificación más alta",
    en: "Rating highest",
  },
  ratingOrderLowest: {
    es: "Calificación más baja",
    en: "Rating lowest",
  },
  rating0: {
    es: "Sin calificar", 
    en: "Not rated",
  },
  rating1: {
    es: "Insatisfactorio",
    en: "Unsatisfactory",
  },
  rating2: {
    es: "Regular",
    en: "Fair",
  },
  rating3: {
    es: "Bueno",
    en: "Good",
  },
  rating4: {
    es: "Muy bueno",
    en: "Great",
  },
  rating5: {
    es: "¡Excelente!",
    en: "Excellent!",
  },
  securePayment: {
    es: "Pago Seguro",
    en: "Secure Payment"
  },
  paymentSummary: {
    es: "RESUMEN DE PAGO",
    en: "PAYMENT SUMMARY"
  },
  standardSecureProcessing: {
    es: "Procesamiento seguro estándar incluyendo todas las tarifas",
    en: "Standard secure processing including all fees"
  },
  paymentProcessor: {
    es: "PROCESADOR DE PAGO",
    en: "PAYMENT PROCESSOR"
  },
  securelyProcessedBy: {
    es: "Procesado de forma segura por",
    en: "Securely processed by"
  },
  promotionCode: {
    es: "CÓDIGO DE PROMOCIÓN",
    en: "PROMOTION CODE"
  },
  enterDiscountCode: {
    es: "Ingresar código de descuento",
    en: "Enter discount code"
  },
  btnApply: {
    es: "Aplicar",
    en: "Apply"
  },
  reservation: {
    es: "Reservación",
    en: "Reservation"
  },
  totalAmount: {
    es: "Monto Total",
    en: "Total Amount"
  },
  cancelTransaction: {
    es: "Cancelar Transacción",
    en: "Cancel Transaction"
  },
  encryptionBadge: {
    es: "ENCRIPTADO AES 256-BIT",
    en: "256-BIT AES ENCRYPTION"
  },
  privacyBadge: {
    es: "PRIVACIDAD GARANTIZADA",
    en: "PRIVACY GUARANTEED"
  },
  confirmationBadge: {
    es: "CONFIRMACIÓN INSTANTÁNEA",
    en: "INSTANT CONFIRMATION"
  },
  success: {
    es: "Éxito",
    en: "Success"
  },
  error: {
    es: "Error",
    en: "Error"
  },
  discountAppliedText: {
    es: "Descuento aplicado",
    en: "Discount applied"
  },
  invalidCoupon: {
    es: "El cupón ya no es válido",
    en: "The coupon is no longer valid"
  },
  validCoupon: {
    es: "Cupón válido",
    en: "Valid coupon"
  },
  btnOk: {
    es: "OK",
    en: "OK"
  },
  offersLoyalty: {
    es: "TRAVEL VOUCHERS Y LOYALTY",
    en: "TRAVEL VOUCHERS & LOYALTY"
  },
  availablePoints: {
    es: "Puntos disponibles",
    en: "Available Points"
  },
  pointsValue: {
    es: "Valor:",
    en: "Value:"
  },
  applyMaxPoints: {
    es: "Aplicar puntos",
    en: "Apply points"
  },
  availableOffers: {
    es: "Travel Vouchers disponibles",
    en: "Available Travel Vouchers"
  },
  selectOffer: {
    es: "Seleccionar",
    en: "Select"
  },
  selectedOffer: {
    es: "Seleccionado",
    en: "Selected"
  },
  promoCodes: {
    es: "Códigos de promoción",
    en: "Promo Codes"
  },
  enterCode: {
    es: "Ingresa el código",
    en: "Enter code"
  },
  noOffersAvailable: {
    es: "No tienes travel vouchers disponibles",
    en: "You have no travel vouchers available"
  },
  vouchersVipOnly: {
    es: "Los travel vouchers solo aplican a semanas VIP Week",
    en: "Travel vouchers only apply to VIP Weeks"
  },
  viewOffers: {
    es: "Ver travel vouchers",
    en: "View travel vouchers"
  },
  changeOffer: {
    es: "Cambiar",
    en: "Change"
  },
  removeOffer: {
    es: "Quitar",
    en: "Remove"
  },
  selectAnOffer: {
    es: "Selecciona un travel voucher",
    en: "Select a travel voucher"
  },
  offersAvailableShort: {
    es: "travel vouchers disponibles",
    en: "travel vouchers available"
  },
  offerSelectedDisableCoupon: {
    es: "Tienes un travel voucher seleccionado",
    en: "You have a selected travel voucher"
  },
  travelVoucher: {
    es: "travel voucher",
    en: "travel voucher"
  },
  coupon: {
    es: "cupón",
    en: "coupon"
  },
  switchCouponOverPoints: {
    es: "Al aplicar un cupón o travel voucher se quitarán los puntos aplicados. ¿Deseas continuar?",
    en: "Applying a coupon or travel voucher will remove the applied points. Do you want to continue?"
  },
  switchPointsOverCoupon: {
    es: "Al aplicar puntos se quitará el {label} aplicado. ¿Deseas continuar?",
    en: "Applying points will remove the applied {label}. Do you want to continue?"
  },
  confirmSwitch: {
    es: "Confirmar cambio",
    en: "Confirm switch"
  },
  tokenRequired: {
    es: "Token requerido. Inicia sesión nuevamente.",
    en: "Token required. Please sign in again."
  },
  notFullyCovered: {
    es: "El descuento no cubre el total.",
    en: "The discount does not cover the total."
  },
  discountCalcError: {
    es: "Error al calcular el descuento",
    en: "Error calculating the discount"
  },
  reserveNotFound: {
    es: "Reserva no encontrada",
    en: "Reservation not found"
  },
  memberNotFound: {
    es: "Socio no encontrado",
    en: "Member not found"
  },
  insufficientPoints: {
    es: "Saldo de puntos insuficiente",
    en: "Insufficient points balance"
  },
  cuponVipWeekRequired: {
    es: "El travel voucher solo es aplicable a semanas VIP Week",
    en: "The travel voucher only applies to VIP Weeks"
  },
  couponNotApplicable: {
    es: "Cupón inválido o no aplicable",
    en: "Invalid or non-applicable coupon"
  },
  offerApplied: {
    es: "Aplicado",
    en: "Applied"
  },
  manualPaymentError: {
    es: "Error al confirmar el pago manual",
    en: "Error confirming manual payment"
  },
  manualPaymentErrorCoupons: {
    es: "Error al confirmar el pago manual con puntos y cupones",
    en: "Error confirming manual payment with points and coupons"
  },
  discountAlreadyApplied: {
    es: "Esta reserva ya tiene aplicado un descuento (cupón/travel voucher o puntos). Recarga o contacta soporte si necesitas revertirlo.",
    en: "This reservation already has a discount applied (coupon/travel voucher or points). Reload or contact support if you need to revert it."
  },
  overpaymentDetected: {
    es: "El total a pagar supera el precio de la reserva. Revisa los descuentos aplicados y reintenta.",
    en: "The total to pay exceeds the reservation price. Check the applied discounts and try again."
  },
  alreadyFullyDiscounted: {
    es: "El saldo de esta reserva ya quedó cubierto con descuentos. No hay nada que cobrar por tarjeta.",
    en: "This reservation balance is already covered by discounts. There is nothing to charge to your card."
  },
  saldoPendienteLabel: {
    es: "Saldo pendiente por tarjeta",
    en: "Balance to pay by card"
  },
  yaCubiertoPorDescuentos: {
    es: "Ya cubierto por descuentos previos",
    en: "Already covered by previous discounts"
  },
  stripeInitError: {
    es: "No se pudo iniciar el pago con tarjeta. Inténtalo nuevamente.",
    en: "Could not start card payment. Please try again."
  },
  newSearch: {
    es: "Nueva búsqueda",
    en: "New search"
  },
  pointsToUse: {
    es: "Puntos a usar",
    en: "Points to use"
  },
  pointsApplied: {
    es: "puntos aplicados",
    en: "points applied"
  },
  couponDiscount: {
    es: "Cupón",
    en: "Coupon"
  },
  pointsDiscount: {
    es: "Puntos",
    en: "Points"
  },
  totalToPay: {
    es: "Total a pagar",
    en: "Total to pay"
  },
  bookNow: {
    es: "Reservar Ahora",
    en: "Book Now"
  },
  cardDetails: {
    es: "DETALLES DE LA TARJETA",
    en: "CARD DETAILS"
  },
  max: {
    es: "MÁX",
    en: "MAX"
  },
  backToSearch: {
    es: "Regresar a la búsqueda",
    en: "Back to search"
  },
  stepSearch: {
    es: "Búsqueda",
    en: "Search"
  },
  stepSelectUnit: {
    es: "Seleccionar unidad",
    en: "Select unit"
  },
  stepContacts: {
    es: "Contactos",
    en: "Contacts"
  },
  stepConfirmation: {
    es: "Confirmación",
    en: "Confirmation"
  },
  availableUnits: {
    es: "Unidades disponibles",
    en: "Available units"
  },
  selectUnit: {
    es: "Seleccionar",
    en: "Select"
  },
  selectAUnit: {
    es: "Selecciona una unidad",
    en: "Select a unit"
  },
  selectReservation: {
    es: "Selecciona una semana",
    en: "Select a week"
  },
  unit: {
    es: "Unidad",
    en: "Unit"
  },
  kitchen: {
    es: "Cocina",
    en: "Kitchen"
  },
  maxGuests: {
    es: "Huéspedes máx.",
    en: "Max guests"
  },
  guests: {
    es: "huéspedes",
    en: "guests"
  },
  perNight: {
    es: "/ noche",
    en: "/ night"
  },
  fixedPrice: {
    es: "Precio fijo",
    en: "Fixed price"
  },
  total: {
    es: "Total",
    en: "Total"
  },
  nonRefundableBanner: {
    es: "Todas las reservas son no reembolsables.",
    en: "All reservations are non-refundable."
  },
  nonRefundableBannerDetail: {
    es: "Una vez confirmada, la reservación no puede modificarse ni cancelarse. Revisa tus fechas y unidad antes de continuar.",
    en: "Once confirmed, the booking cannot be modified or cancelled. Please review your dates and unit carefully before proceeding."
  },
  nonRefundableShort: {
    es: "No reembolsable.",
    en: "Non-refundable."
  },
  nonRefundableFull: {
    es: "Todas las ventas son finales.",
    en: "All sales are final."
  },
  checkInLabel: {
    es: "Check-in",
    en: "Check-in"
  },
  checkOutLabel: {
    es: "Check-out",
    en: "Check-out"
  },
  dates: {
    es: "Fechas",
    en: "Dates"
  },
  specialDates: {
    es: "Fechas especiales",
    en: "Special dates"
  },
  duration: {
    es: "Duración",
    en: "Duration"
  },
  confirmBookingTitle: {
    es: "¿Confirmar reserva?",
    en: "Confirm booking?"
  },
  confirmBookingDesc: {
    es: "Al continuar la reserva sera tuya por 10 minutos, completa los datos y el pago para confirmarla.",
    en: "By continuing, the reservation will be held for you for 10 minutes. Complete your details and payment to confirm it."
  },
  backToResortTitle: {
    es: "¿Volver atrás?",
    en: "Go back?"
  },
  backToResortDesc: {
    es: "Se cancelará el temporizador de reserva.",
    en: "The booking timer will be cancelled."
  },
  ffbSection: {
    es: "Friends & Family",
    en: "Friends & Family"
  },
  ffbNote: {
    es: "Completa el correo electrónico de los Friends & Family de tu membresía. El teléfono es opcional.",
    en: "Complete the email address of your membership Friends & Family. The phone is optional."
  },
  ffbEmailRequired: {
    es: "El correo electrónico es obligatorio",
    en: "The email address is required"
  },
  ffbEmailInvalid: {
    es: "El correo electrónico con formato no válido",
    en: "Invalid email format"
  },
  ffbEmailDuplicate: {
    es: "Este correo electrónico ya está registrado",
    en: "This email address is already registered"
  },
  ffbSaveError: {
    es: "No se pudo guardar uno o más Friends & Family. Corrige los errores e intenta de nuevo.",
    en: "One or more Friends & Family could not be saved. Please fix the errors and try again."
  },
  ffbInvitationNote: {
    es: "Enviaremos una invitación al correo de cada Friends & Family. Deberá aceptarla desde ese enlace para quedar aprobado.",
    en: "We will send an invitation to each Friends & Family email. They must accept it from that link to be approved."
  },
  ffInvitationTitle: {
    es: "Invitación Friends & Family",
    en: "Friends & Family invitation"
  },
  ffInvitationIntro: {
    es: "Fuiste registrado como Friends & Family de esta membresía. Para completar tu registro, confirma que eres mayor de 18 años y acepta la invitación.",
    en: "You were registered as a Friends & Family member of this membership. To complete your registration, confirm that you are 18 or older and accept the invitation."
  },
  ffInvitationInvitedBy: {
    es: "Invitado por",
    en: "Invited by"
  },
  ffInvitationMembership: {
    es: "Membresía",
    en: "Membership"
  },
  ffInvitationExpires: {
    es: "Este enlace vence el",
    en: "This link expires on"
  },
  ffInvitationAgeCheck: {
    es: "Confirmo que soy mayor de 18 años",
    en: "I confirm that I am 18 years or older"
  },
  ffInvitationAccept: {
    es: "Aceptar invitación",
    en: "Accept invitation"
  },
  ffInvitationAccepting: {
    es: "Aceptando...",
    en: "Accepting..."
  },
  ffInvitationAcceptedTitle: {
    es: "¡Invitación aceptada!",
    en: "Invitation accepted!"
  },
  ffInvitationAcceptedMsg: {
    es: "Tu registro como Friends & Family quedó aprobado. Ya puedes disfrutar los beneficios de la membresía.",
    en: "Your Friends & Family registration is approved. You can now enjoy the membership benefits."
  },
  ffInvitationAlreadyAccepted: {
    es: "Esta invitación ya había sido aceptada.",
    en: "This invitation had already been accepted."
  },
  ffInvitationInvalid: {
    es: "La invitación no es válida. Verifica el enlace o solicita uno nuevo.",
    en: "The invitation is not valid. Check the link or request a new one."
  },
  ffInvitationExpired: {
    es: "La invitación expiró. Solicita al titular de la membresía que te envíe una nueva.",
    en: "The invitation expired. Ask the membership owner to send you a new one."
  },
  ffInvitationRevoked: {
    es: "La invitación fue revocada. Solicita al titular de la membresía que te envíe una nueva.",
    en: "The invitation was revoked. Ask the membership owner to send you a new one."
  },
  ffInvitationError: {
    es: "No se pudo procesar la invitación. Intenta de nuevo.",
    en: "The invitation could not be processed. Please try again."
  },
  ffInvitationMissingToken: {
    es: "El enlace no incluye una invitación válida.",
    en: "The link does not include a valid invitation."
  },
  ffInvitationAgeRequired: {
    es: "Debes confirmar que eres mayor de 18 años.",
    en: "You must confirm that you are 18 or older."
  },
  ffInvitationLoginCta: {
    es: "Ir al inicio de sesión",
    en: "Go to sign in"
  },
  ffInvitationCardTitle: {
    es: "Friends & Family",
    en: "Friends & Family"
  },
  ffInvitationCardEmpty: {
    es: "Esta membresía no tiene Friends & Family registrados.",
    en: "This membership has no registered Friends & Family."
  },
  ffInvitationPending: {
    es: "Pendiente",
    en: "Pending"
  },
  ffInvitationApproved: {
    es: "Aprobado",
    en: "Approved"
  },
  ffInvitationExpiredStatus: {
    es: "Expirada",
    en: "Expired"
  },
  ffInvitationRevokedStatus: {
    es: "Revocada",
    en: "Revoked"
  },
  ffInvitationNoEmailStatus: {
    es: "Sin correo",
    en: "No email"
  },
  ffInvitationResend: {
    es: "Reenviar invitación",
    en: "Resend invitation"
  },
  ffInvitationResendOk: {
    es: "Invitación reenviada correctamente.",
    en: "Invitation resent successfully."
  },
  ffInvitationResendError: {
    es: "No se pudo reenviar la invitación.",
    en: "The invitation could not be resent."
  },
  ffInvitationChangeEmailNote: {
    es: "Si cambias el correo, el F&F deberá aceptar una nueva invitación.",
    en: "If you change the email, the F&F must accept a new invitation."
  },

  /* Holiday Weeks */
  holiday: {
    es: "Holiday",
    en: "Holiday",
  },
  anyHoliday: {
    es: "Cualquier holiday · próximos 12 meses",
    en: "Any holiday · next 12 months",
  },
  anywhere: {
    es: "Cualquier destino",
    en: "Anywhere",
  },
  guests: {
    es: "Huéspedes",
    en: "Guests",
  },
  searchHolidayWeeks: {
    es: "Buscar Holiday Weeks",
    en: "Search Holiday Weeks",
  },
  holidayIntro: {
    es: "Elige un holiday y encuentra semanas disponibles en todos los destinos.",
    en: "Pick a holiday and see every week available, in every destination.",
  },
  holidayNext12: {
    es: "Mostrando los próximos 12 meses",
    en: "Showing the next 12 months",
  },
  majorHolidays: {
    es: "Feriados principales",
    en: "Major holidays",
  },
  longWeekends: {
    es: "Puentes largos",
    en: "Long weekends",
  },
  schoolBreaks: {
    es: "Vacaciones escolares",
    en: "School breaks",
  },
  nextUp: {
    es: "Próximo",
    en: "Next up",
  },
  hwAvailable: {
    es: "Disponible",
    en: "Available",
  },
  hwLastWeeks: {
    es: "Últimas semanas",
    en: "Last weeks",
  },
  hwSoldOut: {
    es: "Agotado",
    en: "Sold out",
  },
  notifyMe: {
    es: "Avísame",
    en: "Notify me",
  },
  notifyDone: {
    es: "Te avisaremos",
    en: "We'll let you know",
  },
  notifyHint: {
    es: "Te avisamos si se abren más semanas.",
    en: "We can alert you if more open up.",
  },
  soldOutTitle: {
    es: "No quedan semanas para",
    en: "No weeks left for",
  },
  soldOutBody: {
    es: "Todas las semanas de este holiday están reservadas. Te podemos avisar si se abre alguna.",
    en: "All the weeks for this holiday are booked. We can let you know if one opens up.",
  },
  nearbyHolidays: {
    es: "Holidays cercanos con disponibilidad",
    en: "Holidays nearby with weeks available",
  },
  noResultsFilters: {
    es: "Ninguna semana coincide con estos filtros",
    en: "No weeks match these filters",
  },
  noResultsBody: {
    es: "Prueba quitando algún filtro para ver más semanas.",
    en: "Try removing a filter to see more weeks.",
  },
  clearAll: {
    es: "Limpiar todo",
    en: "Clear all",
  },
  byDestination: {
    es: "Por destino",
    en: "By destination",
  },
  list: {
    es: "Lista",
    en: "List",
  },
  modifySearch: {
    es: "Modificar búsqueda",
    en: "Modify search",
  },
  hwCheckIn: {
    es: "Check-in",
    en: "Check-in",
  },
  hwBedrooms: {
    es: "Recámaras",
    en: "Bedrooms",
  },
  weeksAvailableCount: {
    es: "semanas disponibles",
    en: "weeks available",
  },
  holidayDestination: {
    es: "Destino",
    en: "Destination",
  },
  newBannerTitle: {
    es: "Nuevo: Holiday Weeks",
    en: "New: Holiday Weeks",
  },
  newBannerText: {
    es: "Navidad, Thanksgiving, Spring Break y más, en todos los destinos a la vez.",
    en: "Christmas, Thanksgiving, Spring Break and more, in every destination at once.",
  },
  newBannerCta: {
    es: "Ver Holiday Weeks",
    en: "Browse Holiday Weeks",
  },
  hwAllTitle: {
    es: "Todos los Holiday Weeks",
    en: "All Holiday Weeks",
  },
  hwResults: {
    es: "resultados",
    en: "results",
  },
  nWeeksLeft: {
    es: "Solo quedan",
    en: "Only",
  },
  weeksLeftFor: {
    es: "semanas para",
    en: "weeks left for",
  },
  hwPriceFrom: {
    es: "Precio desde",
    en: "Price from",
  },
  hwRating: {
    es: "Calificación",
    en: "Rating",
  },
  hwRegularWeeks: {
    es: "Explorar semanas regulares",
    en: "Explore regular weeks",
  },
};
